var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Landing1Hero'),_c('Landing2Solution'),_c('Landing3HowItWorks'),_c('Landing3OurProduct1'),_c('Landing4WeHelpYou'),_c('Achievements'),_c('Landing5Testimonials'),_c('Landing6SignUp'),_c('Landing7Faqs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }